import { gql } from '@apollo/client';

export interface HomeQueryResultBooking {
    id: number;
    reference: string;
    status: string;
    invoiceId?: string;
    countryCode: string;
    guestName: string;
    adultCount: number;
    childCount: number;
    infantCount: number;
    revenue: number;
    currency: string;
    actionRequired: boolean;
    urgentActionRequired: boolean;
    bookingShouldBeComplete: boolean;
    detailsRequested: boolean;
    detailsRecorded: boolean;
    hasInstructions: boolean;
    checkin: string;
    checkout: string;
    checkinTime: string;
    checkoutTime: string;
    lockboxCode?: string;
    instructionDownloadCount: number;
    guests: {
        id: number;
        valid: boolean;
    }[];
}

export interface HomeQueryResult {
    home: {
        bookings: HomeQueryResultBooking[];
    };
    cleaningList: {
        id: string;
        time: string;
        note: string;
        value: number;
        paid: boolean;
    }[];
}

export const homeQuery = gql`
    query Home($propertyId: Int!) {
        home(propertyId: $propertyId) {
            bookings {
                id
                reference
                status
                invoiceId
                countryCode
                guestName
                adultCount
                childCount
                infantCount
                revenue
                currency
                actionRequired
                urgentActionRequired
                detailsRequested
                detailsRecorded
                hasInstructions
                bookingShouldBeComplete
                checkin
                checkout
                checkinTime
                checkoutTime
                lockboxCode
                instructionDownloadCount
                guests {
                    id
                    valid
                }
            }
        }
        cleaningList(propertyId: $propertyId) {
            id
            time
            note
            value
            paid
        }
    }
`;

export const statsQuery = gql`
    query countryStats {
        countryStats {
            countryCode
            countryName
            count
            revenue
            revenuePaid
        }
    }
`;

interface CountryStatsRow {
    countryCode: string;
    countryName: string;
    count: number;
    revenue: number;
    revenuePaid: number;
}

type CountryStats = CountryStatsRow[];

export interface StatsQueryResult {
    countryStats: CountryStats;
}

export const bookingStatsQuery = gql`
    query BookingStats($projected: Boolean) {
        stats(projected: $projected) {
            bookings {
                id
                guestName
                checkin
                checkout
                revenue
                currency
                cleaningFee
            }
        }
    }
`;

interface BookingStatsBooking {
    id: number;
    guestName: string;
    checkin: string;
    checkout: string;
    revenue: number;
    currency: string;
    cleaningFee: number;
}

export interface BookingStatsQueryResult {
    stats: {
        bookings: BookingStatsBooking[];
    };
}

export const checklistQuery = gql`
    query Booking($id: Int!) {
        booking(id: $id) {
            id
            countryCode
            reference
            importedToGovernmentPortal
            detailsRequested
            detailsRecorded
            hasInstructions
            accommodationReady
            accommodationVerified
            keysSecured
            hasReview
            countryCode
            lockboxCode
            invoiceId
            guests {
                firstName
            }
            contactPhone
        }
    }
`;

export const alterBookingStateQuery = gql`
    mutation AlterBookingState($id: Int!, $fields: BookingStateInput!) {
        alterBookingState(id: $id, fields: $fields) {
            id
            reference
            importedToGovernmentPortal
            detailsRequested
            detailsRecorded
            hasInstructions
            accommodationReady
            accommodationVerified
            keysSecured
            hasReview
        }
    }
`;
